import React, { useState, useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ColorModeProvider } from './context/ThemeContext';
import CssBaseline from '@mui/material/CssBaseline';
import { RouterProvider } from "react-router-dom";
import router from './routes/Router';
import { LoginProvider } from './context/LoginState';
import { inject } from '@vercel/analytics';

inject();

// Wrapper component to manage theme state
const RootApp = () => {
  // You can initialize this from localStorage if you want to persist the choice
  const [mode, setMode] = useState<'light' | 'dark'>('light');

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
        typography: {
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        },
      }),
    [mode]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LoginProvider>
        <RouterProvider router={router} />
      </LoginProvider>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
<React.StrictMode>
    <ColorModeProvider>
      <CssBaseline />
      <LoginProvider>
        <RouterProvider router={router} />
      </LoginProvider>
    </ColorModeProvider>
  </React.StrictMode>);